import { useState } from "react";

export interface ClientLinkState {
  mode: "none" | "existing" | "new";
  selectedClient: any | null;
  newClientName: string;
  newClientEntityType: string;
  relationshipType: string;
}

export const initialClientLinkState: ClientLinkState = {
  mode: "none",
  selectedClient: null,
  newClientName: "",
  newClientEntityType: "Individual",
  relationshipType: "Other",
};

/** Owns the "link this new contact to a client" mode + form state. */
export function useClientLink() {
  const [clientLink, setClientLink] = useState<ClientLinkState>(initialClientLinkState);

  const resetClientLink = () => setClientLink(initialClientLinkState);

  return { clientLink, setClientLink, resetClientLink };
}
